import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OtpTimerService {
  private countdown = 120; // in seconds
  private timeLeft$ = new BehaviorSubject<number>(0);
  private timerSubscription: Subscription | null = null;

  startCountdown() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.timeLeft$.next(this.countdown);

    this.timerSubscription = interval(1000).pipe(
      takeWhile(() => this.timeLeft$.value > 0)
    ).subscribe(() => {
      const newValue = this.timeLeft$.value - 1;
      this.timeLeft$.next(newValue);
    });
  }

  getTimeLeftObservable() {
    return this.timeLeft$.asObservable();
  }

  isInCooldown(): boolean {
    return this.timeLeft$.value > 0;
  }

  stopTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = null;
    }
  }
}
